import { embedSearchWidgetIsomorphicApiFetchMetadata } from '#/modules/embedSearchWidget/api/embedSearchWidgetApiFetchMetadata';
import { EmbedSearchWidgetContext } from '#/modules/embedSearchWidget/contexts/EmbedSearchWidgetContext';
import type { embedSearchWidgetRouteGroup } from '#/modules/embedSearchWidget/routing/embedSearchWidget.routes';
import { radiusIntToString } from '#/modules/search/helpers/radius';
import type { HorizonAppRouteGroupLoaderArgs } from '#/routing/classes/types/AppRouteGroupLoaderArgs';
import type { HorizonAppRouteComponentProps } from '#/routing/types/HorizonAppRouteComponentProps';
import { idealistRedirect } from '#/routing/utils/idealistRedirect';

import { EmbedSearchWidgetLayoutLoadable } from './EmbedSearchWidgetLayoutLoadable';

export const id = 'embed-search-widget-layout';

export async function loader({
  request,
  context,
  params: { embedSearchWidgetId },
}: HorizonAppRouteGroupLoaderArgs<typeof embedSearchWidgetRouteGroup>) {
  const url = new URL(request.url);
  const hasRadius = url.searchParams.has('radius');

  const [embedSearchWidget] = await Promise.all([
    embedSearchWidgetIsomorphicApiFetchMetadata({ request, context })(
      embedSearchWidgetId,
    ),
    EmbedSearchWidgetLayoutLoadable.load(),
  ]);

  if (
    !hasRadius &&
    embedSearchWidget.location &&
    embedSearchWidget.radius != null
  ) {
    const r = radiusIntToString(
      embedSearchWidget.radius,
      embedSearchWidget.location.geoType,
    );
    if (r) {
      url.searchParams.set('radius', r);
      return idealistRedirect({ request })(url.toString());
    }
  }

  return { embedSearchWidget };
}

export default function EmbedSearchWidgetLayoutHorizonRoute({
  loaderData: { embedSearchWidget },
}: HorizonAppRouteComponentProps<typeof loader>) {
  return (
    <EmbedSearchWidgetContext value={embedSearchWidget}>
      <EmbedSearchWidgetLayoutLoadable embedSearchWidget={embedSearchWidget} />
    </EmbedSearchWidgetContext>
  );
}
